export class CustomerOrderPositionDto {
	public articlelId: string = "";
	public description: string = "";
	public customerPricePerPart: number = 0;
	public menge: number = 0;
}
